import { normalizeApiError } from '@/services/httpError';

const TENANT_ERROR_MESSAGES: Record<string, string> = {
	TENANT_SLUG_ALREADY_EXISTS:
		'This slug is already used by another tenant. Choose another one.',
	TENANT_PROTECTED:
		'The default tenant cannot be suspended: every platform admin belongs to it.',
	TENANT_NOT_FOUND: 'This tenant no longer exists. Refresh the list.',
	PLATFORM_ADMIN_REQUIRED: 'Only platform admins can manage tenants.',
	INVALID_TENANT: 'Check the name and the slug, then try again.',
};

/** Machine-readable code of a tenant API failure, if any. */
export function getTenantErrorCode(error: unknown): string | null {
	return normalizeApiError(error).code;
}

/** User-facing message for a tenant API failure; branches on `code`. */
export function describeTenantError(error: unknown): string {
	const normalized = normalizeApiError(error);
	const known = normalized.code
		? TENANT_ERROR_MESSAGES[normalized.code]
		: undefined;
	return known ?? normalized.message;
}
